import { useFlags } from "launchdarkly-react-client-sdk";
import type { ReactNode } from "react";
import { Button } from "src/components/ui/button";
import config from "src/config";
import { useRedirect } from "src/hooks";
import { MaintenanceIllustration } from "src/images";

export const Maintenance = ({ description }: { description?: string }) => {
  const handleRedirect = useRedirect(config.brandPublicURL);
  return (
    <div className="text-center flex items-center flex-col justify-center h-screen select-none p-4">
      <MaintenanceIllustration width={346} height={217} />
      <p className="text-xl mt-3 mb-3">{config.brandName} is currently down for maintenance</p>
      <p className="leading-[1.5] mb-4">
        {description?.length ? (
          description
        ) : (
          <>
            {" "}
            Our website is currently undergoing some updates and improvements.
            <br />
            We'll be back online soon!
          </>
        )}
      </p>
      <Button size="default" onClick={handleRedirect}>
        Go to {new URL(config.brandPublicURL).hostname.replace(/^www\./, "")}
      </Button>
    </div>
  );
};

const MaintenanceIfEnabled = ({
  flag,
  children,
}: {
  flag: "applicationFlow" | "dashboard";
  children: ReactNode;
}) => {
  const flags = useFlags();
  const maintenanceEnabled = flags[`${flag}MaintenanceEnabled`];
  const maintenanceDescription = flags[`${flag}MaintenanceDescription`];
  return <>{maintenanceEnabled ? <Maintenance description={maintenanceDescription} /> : children}</>;
};

export default MaintenanceIfEnabled;
